import React from 'react';
import { useCategory } from 'hooks';

export default Component => props => (
    <Component {...props} category={useCategory()} />
);
